<template>
  <div>
    <div class="box">
      <div class="aside_header" v-show="flagindex == 3">
        <span>人脉圈&emsp;>&emsp;</span>
        <span>我的推广&emsp;>&emsp;</span>
        <span>我推广的企业&emsp;>&emsp;</span>
        <span style="color: #4b73da">企业主页</span>
      </div>
      <div class="aside_header" v-show="flagindex == 1">
        <span style="color: #4b73da">企业主页</span>
      </div>
      <div class="data_bankbox">
        <div class="data_bankbox_childb">
          <div class="data_childb_a">
            <img :src="list.log_img" alt="" />
            <div class="data_childb_a_child">
              <div>
                <h2 style="padding-right: 10px">{{ list.company_name }}</h2>
              </div>
            </div>
          </div>
          <div class="data_childb_b">
            <div class="data_childb_b_child">
              <div>
                <div>{{ list.popularity }}</div>
                <div>人气</div>
              </div>
              <div>
                <div>{{ list.credit }}</div>
                <div>信用</div>
              </div>
              <div>
                <div>{{ list.fans }}</div>
                <div>粉丝</div>
              </div>
              <div>
                <div>{{ list.follow_count }}</div>
                <div>关注</div>
              </div>
            </div>
            <div class="data_childb_b_childs">
              <div class="btn1" v-show="list.is_follow == 2" @click="attention">
                关注
              </div>
              <div class="btn1" v-show="list.is_follow == 1" @click="cancel">
                已关注
              </div>
              <div class="btn2">联系客服</div>
            </div>
          </div>
        </div>
      </div>

      <div class="content_box">
        <div :class="indexs == index ? 'content_box_childs' : 'content_box_child'" v-for="(item, index) in navlist" :key="index" @click="nav(index)">
          {{ item }}
        </div>
      </div>

      <div v-show="indexs == 0">
        <div class="aside_box">
          <div class="divs">
            <div class="div_child">
              <div class="flag"></div>
              <div class="div_child_s">
                <span>企业介绍</span>
                <span>查看更多&gt;</span>
              </div>
            </div>

            <div class="div_childs">{{ list.description }}</div>
          </div>
        </div>

        <div class="aside_box">
          <div class="divs">
            <div class="div_child">
              <div class="flag"></div>
              <div class="div_child_s">
                <span>产品服务展示</span>
                <span>查看更多&gt;</span>
              </div>
            </div>

            <div class="div_childs">
              <viewer>
                <img src="../../assets/1.jpg" />
              </viewer>
              <viewer>
                <img src="../../assets/1.jpg" />
              </viewer>
              <viewer>
                <img src="../../assets/1.jpg" />
              </viewer>
              <viewer>
                <img src="../../assets/1.jpg" />
              </viewer>
            </div>
          </div>
        </div>

        <div class="aside_box">
          <div class="divs">
            <div class="div_child">
              <div class="flag"></div>
              <div class="div_child_s">
                <span>形象展示</span>
                <span>查看更多&gt;</span>
              </div>
            </div>

            <div class="div_childs">
              <viewer>
                <img src="../../assets/1.jpg" />
              </viewer>
              <viewer>
                <img src="../../assets/1.jpg" />
              </viewer>
              <viewer>
                <img src="../../assets/1.jpg" />
              </viewer>
              <viewer>
                <img src="../../assets/1.jpg" />
              </viewer>
            </div>
          </div>
        </div>

        <div class="aside_box">
          <div class="divs">
            <div class="div_child">
              <div class="flag"></div>
              <div class="div_child_s">
                <span>企业印象</span>
                <span>查看更多&gt;</span>
              </div>
            </div>

            <div class="div_childs">
              <div class="flagsty">高达威猛</div>
              <div class="flagsty">阳光帅气</div>
            </div>
          </div>
        </div>

        <div class="aside_box">
          <div class="divs">
            <div class="div_child">
              <div class="flag"></div>
              <div class="div_child_s">
                <span>用户评价</span>
                <span>查看更多&gt;</span>
              </div>
            </div>

            <div class="div_childs">
              <div v-for="(item, index) in list.assess" :key="index">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="indexs == 1">
        <div class="home_box">
          <div v-for="(item, index) in navlists" :key="index" :class="index1 == index ? 'home_childs' : 'home_child'" @click="navtwo(index)">
            {{ item }}
          </div>
        </div>

        <div v-show="index1 == 0" style="position: relative">
          <div class="data_box">
            <div class="data_child" v-for="(item, index) in joblist" :key="index">
              <div class="data_child_box_a">
                <img :src="item.logo" />
                <div class="data_child_box_childa">
                  <div class="data_child_box_childa_boxa">
                    <span>{{ item.title }}</span>
                    <span style="font-size: 16px; color: red">{{ item.wages }}/{{ item.unit }}</span>
                  </div>
                  <div>
                    {{ item.education_str }}
                  </div>
                </div>
              </div>
              <div class="data_child_box_c">{{ item.description }}</div>
              <div class="data_child_box_b">
                <div>截止日期：剩余{{ item.count_down }}</div>
                <div>
                  空余岗位：<span style="color: red">{{
                    item.surplus_number
                  }}</span>个
                </div>
              </div>
            </div>
          </div>
          <div class="bottom_box">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-size="limit" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
        <div v-show="index1 == 1" style="position: relative">
          <div class="data_box">
            <div class="data_child" style="height: 70px" v-for="(item, index) in projectlist" :key="index">
              <div class="data_child_box_a">
                <img :src="item.image" />
                <div class="data_child_box_childas">
                  <div class="data_child_box_childas_box">
                    <span>{{ item.name }}</span>
                    <div style="display: flex; align-items: center">
                      <div class="dis_box" style="margin-right: 30px">
                        <span>{{ item.job_count }}</span>
                        <span>发布的职位</span>
                      </div>
                      <div class="dis_box">
                        <span>{{ item.crowd_count }}</span>
                        <span>发布的众包</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom_box">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-size="limit" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
        <div v-show="index1 == 2" style="position: relative">
          <div class="data_box">
            <div class="data_child" style="height: 70px" v-for="(item, index) in userlist" :key="index">
              <div class="data_child_box_a">
                <img :src="item.user_avatar" />
                <div class="data_child_box_childas">
                  <div class="data_child_box_childas_box">
                    <span>{{ item.nickname }}</span>
                    <div style="display: flex; align-items: center">
                      <div class="dis_box" style="margin-right: 30px">
                        <span>{{ item.job_count }}</span>
                        <span>发布的职位</span>
                      </div>
                      <div class="dis_box">
                        <span>{{ item.crowd_count }}</span>
                        <span>发布的众包</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom_box">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-size="limit" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
          <div class="bottom_box">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-size="limit" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
      </div>
      <div v-show="indexs == 2">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import {
  companyinfo,
  joblist,
  projectlist,
  userlist,
  companyfollow,
} from "../../api/apply/index";
export default {
  data () {
    return {
      id: "",
      list: {},
      navlist: ["公司主页", "招聘职位", "众包职位"],
      navlists: ["岗位", "项目", "主管"],
      indexs: 0,
      index1: 0,
      limit: 6,
      page: 1,
      joblist: [],
      projectlist: [],
      userlist: [],
      total: 0,
      flagindex: 0,
    };
  },
  created () {
    this.id = this.$route.query.id;
    this.flagindex = this.$route.query.flag;
    this.getlist();
    this.getjoblist();
    this.getprojectlist();
    this.getuserlist();
  },
  mounted () { },
  methods: {
    //关注
    attention () {
      let data = {
        company_app_id: this.id,
        status: 1,
      };
      companyfollow(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "已关注",
          });
          this.getlist();
        }
      });
    },
    //取关
    cancel () {
      let data = {
        company_app_id: this.id,
        status: 2,
      };
      companyfollow(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "取消关注",
          });
          this.getlist();
        }
      });
    },
    //分页
    handleSizeChange (val) {
      this.limit = val;
      if (this.index1 == 0) {
        this.getjoblist();
      }
      if (this.index1 == 1) {
        this.getprojectlist();
      }
      if (this.index1 == 2) {
        this.getuserlist();
      }
    },
    handleCurrentChange (val) {
      this.page = val;
      if (this.index1 == 0) {
        this.getjoblist();
      }
      if (this.index1 == 1) {
        this.getprojectlist();
      }
      if (this.index1 == 2) {
        this.getuserlist();
      }
    },
    getjoblist () {
      let data = {
        company_app_id: this.id,
        limit: this.limit,
        page: this.page,
      };
      joblist(data).then((res) => {
        this.joblist = res.data.data;
        this.total = res.data.total;
      });
    },
    getprojectlist () {
      let data = {
        company_app_id: this.id,
        limit: this.limit,
        page: this.page,
      };
      projectlist(data).then((res) => {
        this.projectlist = res.data.data;
        this.total = res.data.total;
      });
    },
    getuserlist () {
      let data = {
        company_app_id: this.id,
        limit: this.limit,
        page: this.page,
      };
      userlist(data).then((res) => {
        this.userlist = res.data.data;
        this.total = res.data.total;
      });
    },
    nav (index) {
      this.indexs = index;
      if (this.indexs == 1) {
        this.getjoblist()
      }
    },
    navtwo (index) {
      this.index1 = index;
      this.page = 1;
      if (index == 0) {
        this.getjoblist();
      }
      if (index == 1) {
        this.getprojectlist();
      }
      if (index == 2) {
        this.getuserlist();
      }
    },
    getlist () {
      companyinfo({ company_app_id: this.id }).then((res) => {
        this.list = (res && res.data) ? res.data : {};
      }).catch(() => {
        this.list = {};
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  width: 1200px;
  margin: auto;
  .data_box {
    margin-top: 20px;
    border: 1px solid #999999;
    opacity: 1;
    border-radius: 8px;
    padding: 20px 20px 100px 20px;
    display: flex;
    flex-wrap: wrap;
    .data_child {
      padding: 20px;
      width: 44.5%;
      height: 120px;
      margin: 10px;
      border: 1px solid #ccc9cc;
      border-radius: 8px;
      .data_child_box_a {
        width: 100%;
        display: flex;
        align-items: center;
        .data_child_box_childas {
          width: 100%;
          padding-left: 20px;
          height: 60px;
          display: flex;
          align-items: center;
          .data_child_box_childas_box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .dis_box {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }
          }
        }
        .data_child_box_childa {
          width: 100%;
          padding-left: 20px;
          height: 60px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          .data_child_box_childa_boxa {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
        }
      }
      .data_child_box_c {
        margin: 10px 0 10px 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .data_child_box_b {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .bottom_box {
    width: 100%;
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
    margin-bottom: 30px;
  }
  .home_box {
    border: 1px solid #999999;
    opacity: 1;
    border-radius: 8px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    .home_childs {
      margin-left: 30px;
      padding: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 60px;
      margin-right: 40px;
      color: #4c71db;
      border-bottom: 1px solid #4c71db;
    }
    .home_child {
      margin-left: 30px;
      padding: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 60px;
      margin-right: 40px;
    }
  }
  .aside_header {
    padding: 20px 0;
  }

  .aside_box {
    margin-top: 20px;

    .flag {
      width: 12px;
      height: 40px;
      background-color: #4c71db;
    }
    .divs {
      // width: 49%;
      border: 1px solid #999999;
      opacity: 1;
      border-radius: 8px;
      padding: 20px 0;
      .div_child {
        display: flex;
        align-items: center;
        .div_child_s {
          padding-left: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 90%;
        }
      }
      .div_childs {
        padding: 10px 40px;
        display: flex;
        .flagsty {
          padding: 5px 20px;
          background-color: #dedbde;
          margin-right: 20px;
        }
        img {
          width: 150px;
          height: 150px;
          border-radius: 15px;
          margin-right: 25px;
        }
      }
    }
  }
  .content_box {
    margin-top: 40px;
    display: flex;
    align-items: center;
    .content_box_child {
      margin-right: 150px;
      padding-bottom: 20px;
    }

    .content_box_childs {
      margin-right: 150px;
      color: #4f6fcd;
      border-bottom: 2px solid #4f6fcd;
      padding-bottom: 20px;
    }
  }
  .data_bankbox {
    border-radius: 8px;
    padding: 20px 20px 50px 20px;
    background-color: #cccccc;
    color: white;
    .data_bankbox_childa {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .data_bankbox_childb {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      .data_childb_a {
        display: flex;
        align-items: center;
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
        .data_childb_a_child {
          height: 80px;
          display: flex;
          padding-left: 10px;
          justify-content: center;
          align-items: center;
          div:nth-child(1) {
            display: flex;
            align-items: center;
            span {
              font-size: 0.1rem;
              color: black;
              padding: 0 3px;
              background-color: white;
            }
          }
        }
      }
      .data_childb_b {
        width: 800px;
        height: 90px;
        display: flex;
        // flex-direction: column;
        justify-content: center;
        .data_childb_b_childs {
          display: flex;
          align-items: center;
          .btn1 {
            margin-left: 20px;
            margin-right: 20px;
            width: 100px;
            height: 35px;
            color: #4c71db;
            border: 1px solid #4c71db;
            border-radius: 30px;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .btn2 {
            width: 100px;
            height: 35px;
            color: white;
            border-radius: 30px;
            background-color: #4c71db;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .data_childb_b_child {
          display: flex;
          div {
            margin: 0 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
